import { Box, FormHelperText, Typography } from "@mui/material";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { Dispatch, SetStateAction, useContext } from "react";
import { Map } from "schemas/functions";

import BentoBrandsAutocomplete from "components/BentoBrandsAutocomplete";
import ImproveCurrentPitch from "features/Auth/Onboarding/ImproveCurrentPitch";

import styles from "../../styles";

interface Props {
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  pitchEmailValidationVa?: string;
  setPitchEmailValidationVa?: Dispatch<SetStateAction<string | undefined>>;
  dreamBrandValidation?: string;
  setDreamBrandValidation?: Dispatch<SetStateAction<string | undefined>>;
}

const FinalTouchForm = ({
  onboardingForm,
  setOnboardingForm,
  pitchEmailValidationVa,
  setPitchEmailValidationVa,
  dreamBrandValidation,
  setDreamBrandValidation,
}: Props) => {
  const { templates } = useContext(OutreachTemplatesContext);

  const updateWishlistBrands = (newBrands: string[]) => {
    setOnboardingForm((prev) => {
      return {
        ...prev,
        wishlistBrands: newBrands,
      };
    });
    if (newBrands.length > 0 && setDreamBrandValidation) {
      setDreamBrandValidation(undefined);
    }
  };

  return (
    <>
      {!(templates?.length > 0) && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6">What's your current pitch email?</Typography>
          <ImproveCurrentPitch
            onboardingForm={onboardingForm}
            setOnboardingForm={setOnboardingForm}
            fromVaFlow={true}
            pitchEmailValidationVa={pitchEmailValidationVa}
            setPitchEmailValidationVa={setPitchEmailValidationVa}
          />
        </Box>
      )}

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">Dream Brands</Typography>
        <FormHelperText error={!!dreamBrandValidation} sx={styles.helperText}>
          Add a maximum of 10 dream brands below. Your VA will put extra
          attention to pitching (and repitching) to these brands. *
        </FormHelperText>
        <BentoBrandsAutocomplete
          selectedBentoBrands={onboardingForm?.wishlistBrands || []}
          updateSelectedBentoBrands={updateWishlistBrands}
        />
        {dreamBrandValidation && (
          <FormHelperText sx={{ mt: -2 }} error={!!dreamBrandValidation}>
            {dreamBrandValidation}
          </FormHelperText>
        )}
      </Box>
    </>
  );
};

export default FinalTouchForm;
